export default "https://assets.egbcdn.net/assets/packs/_/images/cocktail/cocktail-background-e5604134c0a71ff3f4715636ceff222b.png";